import React from "react"
import RotatingText from '../components/RotatingText'
import { Waves, Button } from '../components';
import { GatsbyImage } from "gatsby-plugin-image";
import { useLocation } from '@reach/router';

const HeroSection = ({ title, subtitle, buttonText, blueBgImageData, bgImageData, showRotatingText, currentPage = '' }) => {
    const location = useLocation();
    const styles = {
        color: 'white',
        marginBottom: '30px',
        paddingRight: '50px',
        lineHeight: '30px',
    };
    return (
        <div className="grid grid-cols-12 w-full h-full relative m-0 p-0">
            <GatsbyImage
                className="absolute w-full h-full"
                style={{ position: "absolute", zIndex: -1 }}
                image={blueBgImageData}
                alt="Background Image"
            />
            <div className="col-span-12 md:col-start-2 md:col-span-5 pt-24 pb-36 px-8 md:px-0 md:mr-8">
                <h1 className="text-5xl text-white font-bold mb-2">{title} {showRotatingText && <RotatingText />}</h1>
                <p style={styles}>{subtitle}</p>
                {buttonText && (
                    location.pathname === '/our-services/property-investments/' ? (
                        <Button
                            color="holborn-greenWhite"
                            href="https://holbornpropertyinvestments.com/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {buttonText}
                        </Button>
                    ) : location.pathname === '/our-services/citizenship-by-investment/' ? (
                        <Button
                            color="holborn-greenWhite"
                            href="https://holbornpass.com/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {buttonText}
                        </Button>
                    ) : (
                        <Button
                            color="holborn-greenWhite"
                            href="/enquiry-form/"
                        >
                            {buttonText}
                        </Button>
                    )
                )}
            </div>
            <div className="col-start-7 col-span-6 relative h-full hidden md:block">
                <GatsbyImage
                    className="absolute w-full h-full"
                    style={{ position: "absolute", zIndex: -1 }}
                    image={bgImageData}
                    alt="Background Image"
                />
            </div>
            <Waves />
        </div>
    );
};

export default HeroSection;